'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('ProjectInfoSelectCtrl', ProjectInfoSelectCtrl);

  ProjectInfoSelectCtrl.$inject = ['$scope'];

  function ProjectInfoSelectCtrl ($scope) {
    $scope.onTreeSelect = function (node, id) {
      $scope.$emit('projectInformationTreeSelect', node, id);
    };

    $scope.determineClasses = function (node) {
      var str = '';
      str += node.selected ? 'selected' : '';
      str += node.disabled ? ' disabled' : '';
      return str;
    };
  }
})();
